import { Button } from "@/components/ui/button";

interface AppBootErrorProps {
  title?: string;
  description?: string;
  onRetry: () => void;
}

export function AppBootError({
  title = "Não foi possível abrir o app",
  description = "Confira sua conexão e tente novamente.",
  onRetry,
}: AppBootErrorProps) {
  return (
    <main className="min-h-[100dvh] bg-background flex items-center justify-center px-6">
      <div className="w-full max-w-sm text-center space-y-4" role="alert">
        <div className="space-y-2">
          <h1 className="text-lg font-semibold text-foreground">{title}</h1>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
        <Button type="button" onClick={onRetry} className="w-full">
          Tentar novamente
        </Button>
      </div>
    </main>
  );
}
